import i18n from "../../../../constants/i18n";
import { PERMISSIONS_TABLE_HEADER } from "../../../../constants/table-custom-headers/Supervisor";
import getPermissionStore from "../../../../stores/supervisor-store/permission-store";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";

const AdminPermissionData = withLiteObserverAndTheme(() => {
  return (
    <Et3Table
      columns={PERMISSIONS_TABLE_HEADER}
      rows={getPermissionStore().adminPermissionsOrdered.get()}
      title={i18n.get("PERMISSIONS_TABLE")}
      shouldBeFlagged={false}
      titleKey={"ADMIN_PERMISSIONS_TABLE"}
    />
  );
});
export default AdminPermissionData;
